<div class="ac-list" appScrollContainer>
  @for (c of criteria(); track trackKey(c)) {
    <div class="ac-list__item" [class.ac-list__item--checked]="c.checked">
      <mat-checkbox
        [checked]="!!c.checked"
        [disabled]="readOnly()"
        [class.ac-list__check--done]="c.checked"
        [attr.aria-label]="'requirements.acceptanceCriteria.toggleChecked' | translate"
        (change)="toggleChecked(c)"
      ></mat-checkbox>
      @if (editingKey() === trackKey(c)) {
        <input
          class="ac-list__edit-input"
          [value]="editText()"
          [attr.maxlength]="fieldLengths.FREETEXT_MAX"
          (input)="onEditTextInput($event)"
          (keydown.enter)="saveEdit()"
          (keydown.escape)="cancelEdit()"
        />
        <button
          mat-icon-button
          type="button"
          [disabled]="!editText().trim()"
          [attr.aria-label]="'requirements.acceptanceCriteria.saveEdit' | translate"
          (click)="saveEdit()"
        >
          <mat-icon aria-hidden="true">check</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="'requirements.acceptanceCriteria.cancelEdit' | translate"
          (click)="cancelEdit()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      } @else {
        <span class="ac-list__text" [class.ac-list__text--checked]="c.checked" (dblclick)="startEdit(c)">
          {{ c.text }}
        </span>
        @if (!editingDisabled()) {
          <button
            type="button"
            class="ac-list__delete"
            [attr.aria-label]="'requirements.acceptanceCriteria.delete' | translate"
            (click)="delete(c)"
          >
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        }
      }
    </div>
  }

  @if (criteria().length === 0) {
    <p class="ac-list__empty">{{ 'requirements.acceptanceCriteria.empty' | translate }}</p>
  }

  @if (!editingDisabled()) {
    <div class="ac-list__add-row">
      <div class="ac-list__add-field">
        <span class="ac-list__add-plus" aria-hidden="true">+</span>
        <input
          class="ac-list__add-input"
          [value]="newText()"
          [attr.maxlength]="fieldLengths.FREETEXT_MAX"
          (input)="onNewTextInput($event)"
          (keydown.enter)="add()"
          [placeholder]="'requirements.acceptanceCriteria.newPlaceholder' | translate"
        />
      </div>
      <button type="button" class="ac-list__add-btn" [disabled]="!newText().trim()" (click)="add()">
        {{ 'requirements.acceptanceCriteria.add' | translate }}
      </button>
    </div>
  }
</div>
